<template>
  <div>
    <el-table
      :data="todayList.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Label" prop="label" sortable></el-table-column>
      <el-table-column label="Title" prop="title" sortable></el-table-column>
      <el-table-column label="Channel" sortable>
      <template slot-scope="{ row }">
        <a :href="'https://www.youtube.com/channel/' + row.channelId" target="_blank">{{row.channelName}}</a>
      </template>
    </el-table-column>
      <el-table-column label="Video ID" prop="videoId">
        <template slot-scope="{ row }">
          <a :href="'https://www.youtube.com/watch?v=' + row.videoId" target="_blank">{{row.videoId}}</a>
        </template>
      </el-table-column>
      <el-table-column label="Claim ID" prop="claimId"></el-table-column>
      <el-table-column label="License" prop="license" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.license == 'Yes'" type="success">
            {{ props.row.license }}
          </el-tag>
          <el-tag v-else type="danger">
            {{ props.row.license }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Keyword" prop="keyword"></el-table-column>
      <el-table-column label="Status" prop="status"></el-table-column>
      <el-table-column label="Date Created" prop="created_at" sortable>
        <template slot-scope="{ row }">
          {{ row.created_at | datetime }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Show video description" placement="top">
            <el-button
                :disabled="props.row.description === null"
                type="info"
                circle
                size="small"
                icon="el-icon-edit"
                @click="handleRowClick(props.row.description)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="justify-content: center"
        background
        @current-change="currentChange"
        :current-page.sync="todayList.current_page"
        :page-size="page_size"
        layout="total, prev, pager, next, jumper"
        :total="todayList.total"
    ></el-pagination>
    <!--  Description Dialog  -->
    <el-dialog
        title="Description"
        :visible="showDescriptionModal"
        width="500px"
        top="3vh"
        :modal="true"
        @close="descModalClose()"
    >
      <div v-html="selectedDescription"></div>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="descModalClose()">
          Close
        </el-button>
      </div>
    </el-dialog>
    <!--  End of Description Dialog  -->
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeClaimLog', [
      'todayList',
      'loading',
      'order_column',
      'order_type',
      'page_size',
      'showDescriptionModal',
      'selectedDescription'
    ])
  },

  methods: {
    ...mapMutations('youtubeClaimLog', ['setPage', 'setDialog', 'setSelectedLabel', "setSelectedDescription", "setShowDescriptionModal"]),
    ...mapActions('youtubeClaimLog', ["getTodayClaims"]),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.getTodayClaims()
    },
    handleRowClick (description) {
      this.setShowDescriptionModal(true)
      this.setSelectedDescription(description)
    },
    descModalClose() {
      this.setShowDescriptionModal(false)
      this.setSelectedDescription('')
    },
    created() {
      this.getTodayClaims()
    }
  }
}
</script>
]
